import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import useResponsive from "@/hooks/useResponsive";
import { CarIcon, Buttons, SecondaryIcon } from "./components";
import Map from "../components/Map";

const Hero = () => {
  const isMobile = useResponsive("down", "lg");
  const isLargeDesktop = useMediaQuery("(max-width: 1535px)");

  return (
    <Box
      component="section"
      pt={{ xs: 9.5, md: 10.5, lg: 2 }}
      pb={{ xs: 6, md: 8, lg: 9.75 }}
      sx={{ overflow: "hidden", position: "relative" }}
    >
      <Container sx={{ position: "relative" }}>
        {isMobile && <CarIcon />}

        <Grid
          container
          columnSpacing={{ xs: 0, lg: 10, xl: 10 }}
          mb={{ xs: 9, lg: 7 }}
        >
          <Grid item xs={12} lg={6}>
            <Box maxWidth={{ lg: 556 }}>
              {!isMobile && <CarIcon />}
              <Typography
                color="text.primary"
                variant="h1"
                mb={{ xs: 2, md: 3 }}
                pt={{ lg: 12 }}
              >
                Simple, Affordable GPS Tracking Solutions                
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                mb={{ xs: 4.25, md: 8, lg: 17 }}
              >
                Whether you’re managing your family’s vehicles or your company’s fleet, Trackmate provides you with the visibility, control, and peace of mind you need at a price you can afford.
              </Typography>

              {!isMobile && <Buttons />}
            </Box>
          </Grid>

          {isLargeDesktop ? <Grid item xs={12} lg={6} sx={{ position: "relative" }}>
            <Box 
              sx={{ 
                display: "flex", 
                justifyContent: "end", 
                position: "relative", 
                paddingBottom: "70px",
              }}
            >
              <Map />
            </Box>
          </Grid> : null}
        </Grid>

        {isMobile && <Buttons />}

        {!isMobile && <SecondaryIcon />}
        {/* <Partners /> */}
      </Container>
      {!isLargeDesktop ? <Map /> : null}
    </Box>
  );
};

export default Hero;
